import React from 'react';

import RunResults from './RunResults';

export default function RunResultsTabView({runId}: {runId: string}): JSX.Element {
  return (
    <div className="react-tab-container">
      <RunResults runId={runId} />
    </div>
  );
}
